import { ID } from "src/types";
import FirebaseService from ".";

type DefaultSublocationChecklistsParams = {
  sublocationTypeId: ID;
  reportType?: string;
  periodId?: ID;
};

type CustomSublocationChecklistsParams = DefaultSublocationChecklistsParams & {
  clientId: ID;
  periodId?: ID;
};

type CustomLocationChecklistsParams = DefaultSublocationChecklistsParams & {
  sublocationTypeId: ID;
  locationId?: ID;
  clientId?: ID;
};

export const getDefaultChecklists = async (reportType: string, periodId?: ID) =>
  FirebaseService.getData({
    ref: `kleenway/checklists/${reportType}/`,
    error: "The entered report type is not recognized",
    orderByChild: "periodId",
    equalTo: periodId,
  });

export const getDefaultSublocationChecklists = async ({
  sublocationTypeId,
  reportType,
  periodId,
}: DefaultSublocationChecklistsParams) =>
  FirebaseService.getData({
    ref: `kleenway/sub-locations/types/${sublocationTypeId}/checklists/${reportType}/`,
    error: "Unable to fetch default sublocation checklists",
    orderByChild: "periodId",
    equalTo: periodId,
  });

export const getCustomSublocationChecklists = async ({
  clientId,
  sublocationTypeId,
  reportType,
  periodId,
}: CustomSublocationChecklistsParams) =>
  FirebaseService.getData({
    ref: `clients/${clientId}/sub-locations/types/${sublocationTypeId}/checklists/${reportType}/`,
    error: "Unable to fetch client sublocation checklists",
    orderByChild: "periodId",
    equalTo: periodId,
  });

export const getClientLocationChecklists = async ({
  clientId,
  sublocationTypeId,
  reportType,
  periodId,
}: CustomLocationChecklistsParams) =>
  FirebaseService.getData({
    ref: `clients/${clientId}/locations/types/${sublocationTypeId}/checklists/${reportType}/`,
    error: "Unable to fetch client location checklists",
    orderByChild: "periodId",
    equalTo: periodId,
  });

export const getChecklistsByLocationAndSublocation = async ({
  locationId,
  sublocationTypeId,
  reportType,
  periodId,
}: CustomLocationChecklistsParams) =>
  FirebaseService.getData({
    ref: `locations/${locationId}/sub-locations/types/${sublocationTypeId}/checklists/${reportType}`,
    error: "Unable to fetch checklists by location and sub-location",
    orderByChild: "periodId",
    equalTo: periodId,
  });

export const getChecklistsByLocation = async ({ locationId, reportType, periodId }: CustomLocationChecklistsParams) =>
  FirebaseService.getData({
    ref: `locations/${locationId}/checklists/${reportType}`,
    error: "Unable to fetch checklists by location",
    orderByChild: "periodId",
    equalTo: periodId,
  });

export const getChecklistsByClient = async ({ clientId, reportType, periodId }: CustomLocationChecklistsParams) =>
  FirebaseService.getData({
    ref: `clients/${clientId}/checklists/${reportType}`,
    error: "Unable to fetch checklists by client",
    orderByChild: "periodId",
    equalTo: periodId,
  });
